function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ThunkHelper } from 'invision-core';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import { values } from 'ramda';
export var ENTITLEMENT_BALANCES_TO_UPDATE = {
  BEGIN: 'ENTITLEMENT_TO_UPDATE_BEGIN',
  SUCCESS: 'ENTITLEMENT_TO_UPDATE_SUCCESS',
  FAILURE: 'ENTITLEMENT_TO_UPDATE_FAILURE'
};
export var ENTITLEMENTS_TO_UPDATE_TYPES = values(ENTITLEMENT_BALANCES_TO_UPDATE);
export var retrieveEntitlementsToUpdatePromise = function retrieveEntitlementsToUpdatePromise(dispatch, customerId, serviceIdentifier) {
  return ThunkHelper(dispatch, ENTITLEMENTS_TO_UPDATE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveEntitlementBalances',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      ServiceIdentifier: serviceIdentifier || null
    }
  });
};
export var retrieveEntitlementsToUpdate = function retrieveEntitlementsToUpdate(customerId, serviceIdentifier) {
  return function (dispatch) {
    return retrieveEntitlementsToUpdatePromise(dispatch, customerId, serviceIdentifier);
  };
};
export var ENTITLEMENT_BALANCE_UPDATE = {
  BEGIN: 'ENTITLEMENT_BALANCE_UPDATE_BEGIN',
  SUCCESS: 'ENTITLEMENT_BALANCE_UPDATE_SUCCESS',
  FAILURE: 'ENTITLEMENT_BALANCE_UPDATE_FAILURE'
};
export var entitlementBalanceUpdate = function entitlementBalanceUpdate(requestData, customerId) {
  return function (dispatch) {
    return ThunkHelper(dispatch, values(ENTITLEMENT_BALANCE_UPDATE), {
      method: 'post',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      url: 'SubscriberManagement/UpdateEntitlementBalance',
      data: requestData
    });
  };
};
export var SET_SELECTED_ENTITLEMENT = 'SET_SELECTED_ENTITLEMENT';
export var setSelectedEntitlement = function setSelectedEntitlement(entitlement) {
  return {
    type: SET_SELECTED_ENTITLEMENT,
    payload: entitlement
  };
};